import React from 'react';
import { routes as r } from '../../routes';
import { MyTeamOverview } from './MyTeamOverview';
import { MyTeamChangeRequests } from './MyTeamChangeRequests';
import {
  CompensationReviewsSubtab,
  CompensationReviewSubtabDetail,
} from '../CompensationReviews/subtab';

export const routes = () => ({
  myTeamOverview: {
    route: r.myTeamOverview.route,
    render: () => <MyTeamOverview />,
  },
  myTeamChangeRequests: {
    route: r.myTeamChangeRequests.route,
    render: () => <MyTeamChangeRequests />,
  },
  myTeamCompensationReviewDetail: {
    route: r.myTeamCompensationReview.route,
    render: () => <CompensationReviewSubtabDetail />,
  },
  myTeamCompensationReviews: {
    route: r.myTeamCompensationReviews.route,
    render: () => <CompensationReviewsSubtab />,
  },
});
